import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { onUploadStatus } from "../lib/compress";

const kb = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.round(n / 1024)} KB`);

export const UploadProgress = () => {
  const [s, setS] = useState(null);
  useEffect(() => onUploadStatus(setS), []);
  if (!s) return null;
  const pct = s.stage === "compress" ? 15 : 15 + Math.round(s.pct * 0.85);
  return (
    <div data-testid="upload-progress" className="fixed top-4 left-1/2 z-[100] w-[min(92vw,380px)] -translate-x-1/2 rounded-xl border bg-card p-3 shadow-xl">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <Loader2 className="h-4 w-4 animate-spin text-primary" />
        <span data-testid="upload-progress-message">{s.optimizable ? "Compressing and uploading document..." : "Uploading document..."}</span>
      </div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-secondary">
        <div className="h-full bg-primary transition-[width] duration-200" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-1 truncate text-[11px] text-muted-foreground" data-testid="upload-progress-size">
        {s.name}{!s.optimizable ? "" : s.to ? ` · ${kb(s.from)} → ${kb(s.to)}` : " · optimizing…"}
      </div>
    </div>
  );
};
